import confetti from 'canvas-confetti'
import { onGameEvent, EVENTS } from './game-events.js'
import { getDialog } from './modals.js'
import { getLastValidWordTiles, getValidWordRows } from './dom.js'
import { prefersReducedMotion } from './preferences.js'

/**
 * Fired once, only when a guess actually wins the game (see
 * itword/views.py) - unlike GAME_LOADED, which fires on every load and
 * would otherwise replay this every time a finished game's page reloads.
 *
 * guess-submitted.js schedules the winning row's flip independently, so
 * this waits for that row's last tile to finish before celebrating.
 */
onGameEvent(EVENTS.GAME_FINISHED, () => {
    const dialog = getDialog('game-finished-modal')
    if (!dialog) return

    const winningTiles = getLastValidWordTiles()
    const lastWinningTile = winningTiles[winningTiles.length - 1]
    if (!lastWinningTile) return

    lastWinningTile.addEventListener('animationend', () => celebrate(dialog), {
        once: true,
    })
})

const celebrate = (dialog) => {
    // The first letter of every guessed row spells out the ItWord - pulse
    // that column together before opening the modal.
    const itWordTiles = Array.from(getValidWordRows()).map((row) =>
        row.querySelector('.valid-word-letter')
    )
    itWordTiles.forEach((tile) => {
        // `opacity-0` is only overridden by the flip animation's forwards
        // fill, which a second animate-* class would otherwise replace.
        tile.classList.remove('opacity-0')
        tile.classList.add('animate-itword-pulse')
    })

    const lastItWordTile = itWordTiles[itWordTiles.length - 1]
    if (!lastItWordTile) return

    lastItWordTile.addEventListener(
        'animationend',
        () => {
            setTimeout(() => {
                // The page behind the modal still shows the in-progress
                // game, so reload on close to render the finished state.
                dialog.on('hide', () => window.location.reload())
                dialog.show()
                if (!prefersReducedMotion()) {
                    confetti({
                        particleCount: 100,
                        spread: 70,
                    })
                }
            }, 400)
        },
        { once: true }
    )
}
